import React from 'react';
import { SystemSettings } from '../../types/systemSettings';

export default function InactivePromotionNotice({ systemSettings }: { systemSettings?: Partial<SystemSettings> | null }) {
  return <section className="promotion-card promotion-inactive-notice" aria-labelledby="inactive-notice-title">
    <h2 id="inactive-notice-title" className="promotion-section-title">프로모션 종료 안내</h2>
    <div className="promotion-inactive-summary">
      <h3>{systemSettings?.inactivePromotionTitle || '프로모션 종료'}</h3>
      <p className="promotion-inactive-message">{systemSettings?.inactivePromotionMessage || '해당 프로모션은 종료되었습니다.'}</p>
    </div>
    <div className="promotion-inactive-guide"><h3>안내사항</h3>
      <p>{systemSettings?.inactivePromotionGuide || '담당자에게 현재 진행 중인 프로모션을 문의해주세요.'}</p>
    </div>
  </section>;
}
